import { RouteConfig } from 'vue-router';

const ZbsjkSelect = () => import(/* webpackChunkName: "Zbsjk" */  './views/zbsjk-select.vue');
const ZbsjkList = () => import(/* webpackChunkName: "Zbsjk" */  './views/zbsjk-list/zbsjk-list.vue');
const ZbsjkDetail = () => import(/* webpackChunkName: "Zbsjk" */  './views/zbsjk-detail/zbsjk-detail.vue');
const ZbsjkDataExport = () => import(/* webpackChunkName: "Zbsjk" */  './views/data-export/data-export.vue');



const routers: RouteConfig[] = [
    {
        path: 'zbsjk-select',
        component: ZbsjkSelect,
    },
    {
        path: 'zbsjk-list',
        component: ZbsjkList,
    },
    {
        path: 'zbsjk-detail',
        component: ZbsjkDetail,
    },
    {
        path: 'zbsjk-data-export',
        component: ZbsjkDataExport,
    },
    {
        path: '',
        redirect: 'zbsjk-select'
    }
];

export default routers;
